<script setup lang="ts">
import { AlphabetTabsProps } from "./AlphabetTabs.props"
import { UPPERCASE_ALPHABET } from "~/utils/constants"
import { checkEnvSite } from "~~/server/utils/getAlgoliaConfig"

const props = defineProps<AlphabetTabsProps>()

const router = useRouter()
const { setPageInfo } = usePageInfo()

const aisComponent = ref(null)
const indexWikiArticlesName = ref(`TOP_WIKI_ARTICLES${checkEnvSite()}`)
const algoliaSearch = useAlgoliaSearch(indexWikiArticlesName.value)
const isLoading = ref(true)
const firstLetter = useState<string>("listingWikiArticles", () => "")

const listingLetterWiki = ref(`listingWikiArticles-letter${firstLetter.value}`)

const setLetter = (letter: string, updateQueryParam?: boolean) => {
  const newLetter = letter === "" ? "" : letter

  if (updateQueryParam) {
    router.replace({ query: { ...(newLetter ? { letter: newLetter } : {}) } })
  }

  firstLetter.value = newLetter

  setPageInfo({
    query: "",
    filterString: filters.value,
    facetFilterString: newLetter
  })
}
const results = ref<null | { hits: any[] }>(null)

const filters = computed(() => `category.slug:${props.category.slug}`)
watch(
  () => props.category.slug,
  () => setLetter(props.letter || ""),
  { immediate: true }
)

try {
  results.value = await algoliaSearch.search({
    query: "",
    requestOptions: {
      filters: filters.value,
      clickAnalytics: true,
      attributesToRetrieve: ["firstLetter"],
      hitsPerPage: 1000
    }
  })
} catch (error) {
  console.log(error)
} finally {
  isLoading.value = false
}

const { t } = useI18n()

const myTabs = computed(() => {
  const facetHits = [
    ...new Set(
      results.value?.hits.map((hit) => hit.firstLetter.toUpperCase()) ?? []
    )
  ]

  return [
    { text: t("wiki.allFilters"), value: "", disabled: false },
    ...UPPERCASE_ALPHABET.map((letter) => ({
      text: letter,
      value: letter,
      disabled: !facetHits.includes(letter)
    })),
    {
      text: "#",
      value: "#",
      disabled: !facetHits.includes("#")
    }
  ]
})

setPageInfo({
  query: "",
  filterString: filters.value
})

onMounted(() => props?.letter && setLetter(props.letter))
</script>

<template>
  <div class="wrapper-pages-wiki-alphabed_tabs">
    <UtilsBreadcrumbs v-bind="breadcrumbs" />

    <BannerWikiMagazine :title="category.name" />

    <div class="wrapper-custom-tabs">
      <div
        class="
          padded
          border-black-10
          flex
          overflow-x-scroll
          border-b
          scrollbar-hide
          md:justify-between
          md:overflow-x-auto
        "
      >
        <ClientOnly>
          <button
            v-for="(tab, index) in myTabs"
            :key="`tab-${index}`"
            class="pig-medium disabled:text-black-20 shrink-0 px-4 py-2"
            :class="{
              'beaver-bold border-green-main text-green-main border-b-[3px]':
                tab.value === firstLetter
            }"
            @click="setLetter(tab.value, true)"
            :disabled="tab.disabled"
            tabindex="1"
          >
            {{ tab.text }}
          </button>
        </ClientOnly>
      </div>
      <div class="padded flex flex-col gap-4 py-6">
        <h2 class="beaver-medium pig-medium">
          {{ $t("wiki.categories.inThisCategory") }}
        </h2>

        <AlgoliaListingPageWiki ref="listingLetterWiki" :letter="firstLetter">
          <template #wikis="slotProps">
            <div class="container-wiki" ref="aisComponent">
              <div class="grid-container gap-4 md:gap-6">
                <CardWiki
                  v-for="(card, index) in slotProps.items"
                  v-bind="card"
                  class="col-span-full md:col-span-4"
                  :key="`card-${index}`"
                />
              </div>
            </div>
            <div class="grid-standard">
              <AlgoliaPagination
                class="
                  col-span-4 col-start-1
                  mt-6
                  block
                  md:col-span-8 md:col-start-3
                  lg:col-start-3
                "
              />
            </div>
          </template>
        </AlgoliaListingPageWiki>
      </div>
    </div>

    <CartUtilsLogin show-login-button />
  </div>
</template>
